import cx from 'classnames';
import React, { HTMLProps, PropsWithChildren } from 'react';

import { LocalHeroIcon } from './LocalHeroIcon';

import style from './LocalHeroBadge.module.css';

export type LocalHeroBadgeProps = PropsWithChildren<HTMLProps<HTMLSpanElement>>;

export function LocalHeroBadge(props: LocalHeroBadgeProps) {
    const { className, children, ...rest } = props;
    return (
        <span className={cx([style.localHeroBadge, className])} {...rest}>
            <LocalHeroIcon width="20" height="20" className={style.localHeroIcon} />
            {children}
        </span>
    );
}
